module.exports = __webpack_public_path__ + "static/Untitled-1-12-bb7d0dedc07556566420f9aab4353155.jpg";